"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_TYPE = void 0;
var ICON_TYPE = {
  small: {
    size: 'normal'
  },
  normal: {
    color: 'greyDark',
    size: 'titleNormal'
  },
  large: {
    size: 'large'
  }
};
exports.ICON_TYPE = ICON_TYPE;